import React from 'react';
import { WorkdayIntegrationPage } from '@workboard/ui-org-admin';
import { createRoot } from 'react-dom/client';

declare global {
  interface Window {
    WorkdayIntegrationAdminPage?: (props?: object, ele?: HTMLElement | null) => void;
  }
}

const rootsByElement = new WeakMap<HTMLElement, ReturnType<typeof createRoot>>();


const WorkdayIntegrationAdminPage = (props: object = {}, ele?: HTMLElement | null) => {

  if (!ele) return;
  const existingRoot = rootsByElement.get(ele);
  if (existingRoot) {
    existingRoot.unmount();
    rootsByElement.delete(ele);
  }
  const root = createRoot(ele);
  rootsByElement.set(ele, root);

  root.render(React.createElement(WorkdayIntegrationPage));
};


window.WorkdayIntegrationAdminPage = WorkdayIntegrationAdminPage;
